const IncreasedArrow = () => (
    <svg
        width='14'
        height='9'
        viewBox='0 0 14 9'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M6.25513 0.329409C6.61241 -0.109802 7.38759 -0.109803 7.74487 0.329408L13.8429 7.82568C14.249 8.32487 13.8207 9 13.098 9H0.901989C0.179268 9 -0.248966 8.32488 0.157115 7.82568L6.25513 0.329409Z'
            fill='#2DCABB'
        />
    </svg>
);

export default IncreasedArrow;
